// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__3T5EZ","dialogHeader":"styles_dialogHeader__bLesT","link":"styles_link__rSrnl"};